////declare global {
////	interface Window {
////		tinymce: any
////	}
////}
(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("learningItemAdd", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/learningItems/add/learningItemAddView.html",
            controller: ["learningItemResource", "messageService", "$q", "$uibModal", "$state", "$translate", "$localStorage", "$timeout", "_", LearningItemAddCtrl],
            controllerAs: "vm"
        };
        function LearningItemAddCtrl(learningItemResource, messageService, $q, $uibModal, $state, $translate, $localStorage, $timeout, _) {
            var vm = this;
            vm.step = 1;
            vm.language = "";
            vm.expiresValidation = "";
            vm.showManageSeminars = false;
            vm.showManageWebinars = false;
            vm.nextButtonText = "common.next";
            vm.showErrors = false;
            vm.confirmButtonEnabled = true;
            vm.showManageTranslations = $localStorage.tenantSettings.enabledLocalizations.length > 1;
            var lang = $translate.proposedLanguage() || $translate.use();
            lang = lang.replace("-", "_");
            vm.formData = {
                type: {},
                typeId: 0,
                commonInfo: {
                    expires: false,
                    expireYears: 0,
                    expireMonths: 0,
                    expireDays: 0
                },
                specificInfo: {}
            };
            learningItemResource.getCreateViewModel(function (result) {
                vm.language = result.localizationName;
                vm.learningItemTypes = result.types;
                vm.gamificationPointCollectionEnabled = result.gamificationPointCollectionEnabled;
                vm.formData.commonInfo.gamificationPoints = result.gamificationPoints;
                vm.evaluations = _.reject(vm.learningItemTypes, function (item) { return item.shape === "circle"; });
                vm.learnings = _.reject(vm.learningItemTypes, function (item) { return item.shape === "square"; });
            });
            $timeout(function () {
                vm.wizard = {
                    form: vm.form,
                    vm: vm,
                    formData: vm.formData
                };
            });
            /////////////////////////////////////////////////////////////////////////
            vm.tinymceInlineOptions = {
                menubar: false,
                resize: true,
                inline: true,
                height: 200,
                plugins: "code, paste, textcolor, autoresize, link",
                toolbar: "bold italic underline strikethrough superscript subscript | forecolor backcolor | undo bullist numlist | link",
                forced_root_block: false,
                default_link_target: "_blank",
                language: lang,
                setup: function (editor) {
                    editor.on("init", function () {
                        // Default classes of tinyMCE are a bit weird
                        // I add my own class on init
                        // this also sets the empty class on the editor on init
                        if (editor.getContent() === "")
                            window.tinymce.DOM.addClass(editor.bodyElement, "content-editor empty");
                        else
                            window.tinymce.DOM.addClass(editor.bodyElement, "content-editor");
                    });
                    editor.on("focus", function () {
                        window.tinymce.DOM.removeClass(editor.bodyElement, "empty");
                    });
                    editor.on("blur", function () {
                        if (editor.getContent() === "") {
                            window.tinymce.DOM.addClass(editor.bodyElement, "empty");
                        }
                        else {
                            window.tinymce.DOM.removeClass(editor.bodyElement, "empty");
                        }
                    });
                }
            };
            //prevents changing the URL to access the other steps
            $timeout(function () {
                if ($state.current.name.indexOf("step" + vm.step) === -1) {
                    $state.go("main.learningItems.add.step" + vm.step);
                }
            });
            //$scope.$on("$viewContentLoaded", function () {
            //	if ($state.current.name.indexOf("step" + vm.step) === -1) {
            //		$state.go("main.learningItems.add.step" + vm.step);
            //	}
            //});
            vm.save = function () {
                vm.confirmButtonEnabled = false;
                switch (vm.formData.typeId) {
                    case 2:
                        vm.showManageTranslations = false;
                        break;
                    case 6:
                        if (vm.formData.specificInfo.url !== undefined &&
                            vm.formData.specificInfo.url !== null &&
                            vm.formData.specificInfo.url !== "") {
                            if (vm.formData.specificInfo.url.indexOf("http://") === -1 &&
                                vm.formData.specificInfo.url.indexOf("https://") === -1 &&
                                vm.formData.specificInfo.url.indexOf("ftp") === -1) {
                                vm.formData.specificInfo.url = "http://" + vm.formData.specificInfo.url;
                            }
                        }
                        break;
                    case 7:
                        vm.showManageTranslations = false;
                        vm.showManageSeminars = true;
                        break;
                    case 8:
                        vm.showManageTranslations = false;
                        if (vm.formData.specificInfo.webinarTypeId === 1) {
                            vm.showManageWebinars = true;
                        }
                        vm.formData.specificInfo.archiveDetails = _.map(vm.formData.specificInfo.archiveDetails, function (archiveDetail) {
                            if (archiveDetail) {
                                if (archiveDetail.url.indexOf("http://") === -1 &&
                                    archiveDetail.url.indexOf("https://") === -1 &&
                                    archiveDetail.url.indexOf("ftp") === -1)
                                    archiveDetail.url = "http://" + archiveDetail.url;
                                return archiveDetail;
                            }
                            return null;
                        });
                        break;
                }
                vm.formData.commonInfo.expireDays = vm.formData.commonInfo.expireDays === "" ? 0 : parseInt(vm.formData.commonInfo.expireDays, 10);
                vm.formData.commonInfo.expireMonths = vm.formData.commonInfo.expireMonths === "" ? 0 : parseInt(vm.formData.commonInfo.expireMonths, 10);
                vm.formData.commonInfo.expireYears = vm.formData.commonInfo.expireYears === "" ? 0 : parseInt(vm.formData.commonInfo.expireYears, 10);
                learningItemResource.save(vm.formData, function (learningItem) {
                    vm.goToStep(5);
                    vm.learningItem = learningItem;
                }, function () {
                    vm.confirmButtonEnabled = true;
                    messageService.error("common.genericError");
                });
            };
            vm.setType = function (id, stateName, expiryEnabled, name, iconCssClass) {
                vm.formData.type = {};
                vm.formData.typeId = id;
                vm.formData.type.id = id;
                vm.formData.type.stateName = stateName;
                vm.formData.type.expiryEnabled = expiryEnabled;
                vm.formData.type.name = name;
                vm.formData.type.iconCssClass = iconCssClass;
                if (!expiryEnabled) {
                    vm.formData.commonInfo.expires = false;
                }
                vm.goToStep(2);
            };
            vm.goToStep = function (step) {
                if (vm.form.$valid || step === 2 || step < vm.step) {
                    vm.showErrors = false;
                    vm.step = step;
                    if (step === 4)
                        vm.nextButtonText = "common.confirm";
                    else
                        vm.nextButtonText = "common.next";
                    $state.go("main.learningItems.add.step" + vm.step);
                }
                else {
                    vm.showErrors = true;
                }
            };
            vm.setExpiresValidation = function () {
                var years = parseInt(vm.formData.commonInfo.expireYears, 10) || 0;
                var months = parseInt(vm.formData.commonInfo.expireMonths, 10) || 0;
                var days = parseInt(vm.formData.commonInfo.expireDays, 10) || 0;
                if (years + months + days > 0)
                    vm.expiresValidation = "expires"; // any value will do
                else
                    vm.expiresValidation = "";
            };
            vm.checkCodeIsAvailable = function (code) {
                return $q(function (resolve, reject) {
                    learningItemResource.getIsCodeAvailable({ code: code }, function (result) {
                        if (result.value)
                            resolve(true);
                        else
                            reject();
                    });
                });
            };
            vm.previewLearningItem = function () {
                $uibModal.open({
                    templateUrl: "app/learningItems/preview/learningItemPreviewModal.html",
                    controller: "LearningItemPreviewModalCtrl as vm",
                    resolve: {
                        previewData: function () {
                            var data = {
                                typeName: vm.formData.type.name,
                                typeIconCssClass: vm.formData.type.iconCssClass,
                                typeId: vm.formData.typeId,
                                itemName: vm.formData.commonInfo.name,
                                itemPriorityItem: vm.formData.commonInfo.priority,
                                itemExpires: vm.formData.commonInfo.expires,
                                itemExpireDays: vm.formData.commonInfo.expireDays,
                                itemExpireMonths: vm.formData.commonInfo.expireMonths,
                                itemExpireYears: vm.formData.commonInfo.expireYears,
                                itemTimeDays: vm.formData.commonInfo.timeDays,
                                itemTimeHours: vm.formData.commonInfo.timeHours,
                                itemTimeMinutes: vm.formData.commonInfo.timeMinutes,
                                itemDescription: vm.formData.commonInfo.description,
                                specificInfo: vm.formData.specificInfo
                            };
                            return data;
                        }
                    }
                }).result.catch(angular.noop);
            };
            //vm.publishText = "learningItem.add.complete.jumbotron.publish.text";
            //vm.publishLearningItem = function () {
            //	vm.learningItemPublished = true;
            //	vm.publishText = "learningItem.add.complete.jumbotron.publishing.text";
            //	vm.learningItem.$publish(function () {
            //		vm.publishText = "learningItem.add.complete.jumbotron.published.text";
            //	}, function () {
            //		vm.publishText = "learningItem.add.complete.jumbotron.publish.text";
            //		vm.learningItemPublished = false;
            //		messageService.error("common.genericError");
            //	});
            //}
            vm.manageLocalizationsState = function () {
                switch (vm.formData.typeId) {
                    case 1:
                        return "main.learningItems.edit.downloadable({ code: vm.learningItem.code })";
                    case 2:
                        return "main.learningItems.edit({ code: vm.learningItem.code })";
                    case 3:
                        return "main.learningItems.edit.onlineExam({ code: vm.learningItem.code })";
                    case 4:
                        return "main.learningItems.edit.onlineLesson({ code: vm.learningItem.code })";
                    case 5:
                        return "main.learningItems.edit.practicalEvaluation({ code: vm.learningItem.code })";
                    case 6:
                        return "main.learningItems.edit.url({ code: vm.learningItem.code })";
                    case 7:
                        return "main.learningItems.edit({ code: vm.learningItem.code })";
                    default:
                        return "main.learningItems.edit({ code: vm.learningItem.code })";
                }
            };
            vm.manageSeminars = function () {
                //PBI 7096
                return "main.learningItems.manageSeminars({ seminarName: vm.formData.commonInfo.name })";
            };
            vm.manageWebinars = function () {
                return "main.learningItems.addWebinarSession({ code: vm.learningItem.code })";
            };
        }
    });
}());
